import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getInvoiceSMSDetail(invoiceId) {
        const options = {
            method: "POST",
            headers: { "content-type": "application/x-www-form-urlencoded" },
            data: "invoice_id=" + invoiceId,
            url: `${baseURLci}billing/invoice/sms`
        };

        return Axios(options).then(response => response.data.response);
    },
    sendSMS(invoiceId, params) {
        return Axios.post(
            `${baseURL}communication/invoice/sms/${invoiceId}`,
            params
        ).then(response => response.data.response);
    },
    applyDiscount(params) {
        return Axios.post(
            `${baseURL}billing/invoice/apply-discount`,
            params
        ).then(response => response.data.response);
    },
    removeDiscount(invoiceId) {
        return Axios.post(`${baseURL}billing/invoice/remove-discount`, {
            id: invoiceId
        }).then(response => response.data.response);
    },
    syncVetsourceOrder(params) {
        return Axios.post(
            `${baseURL}billing/sync/vetsource/order`,
            params
        ).then(response => response.data.response);
    }
};
